<div class="app-list-table">
  <div class="app-list-header"
       *ngIf="!hideHeader"
       fxLayout="row"
       fxLayoutAlign="start center"
       fxLayoutGap="8px"
       fxLayoutGap.gt-xs="24px">
    <div *ngIf="form" class="app-list-name">
      <form [formGroup]="form">
        <mat-form-field class="system-form-field" fxFlex style="margin-top: 15.5px;">
          <mat-label>Buscar por:</mat-label>
          <mat-select formControlName="search" [panelClass]="'panel-system'">
            <mat-option *ngFor="let filt of filterArray" value="{{filt.id}}">{{filt.name}}</mat-option>
          </mat-select>

        </mat-form-field>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex>

          <mat-form-field *ngIf="selectDex" fxFlex style="margin-top: 15.5px; margin-left: 7.5px;" class="system-form-field mat-date-default">
            <mat-label>Nombre DEX</mat-label>
            <mat-select formControlName="dex" panelClass="panel-system custom-class-dex">
              <mat-option *ngFor="let filt of dexs" value="{{filt.distributorCode}}">{{filt.distributorCode}} - {{filt.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="!selectDex" fxFlex style="margin-top: 15.5px; margin-left: 7.5px;" class="system-form-fieldat-date-default">
            <mat-label>Fecha Inicial</mat-label>
            <input matInput formControlName="startDate" [matDatepicker]="startDate" [max]="today">
            <mat-datepicker-toggle matIconSuffix [for]="startDate"></mat-datepicker-toggle>
            <mat-datepicker #startDate [panelClass]="'panel-system'"></mat-datepicker>
          </mat-form-field>

          <mat-form-field *ngIf="!selectDex && (maxDays == 0)" fxFlex style="margin-top: 15.5px; margin-left: 7.5px;" class="system-form-fieldat-date-default">
            <mat-label>Fecha Final</mat-label>
            <input matInput formControlName="endDate" [matDatepicker]="endDate" [max]="today" [min]="maxDate">
            <mat-datepicker-toggle matIconSuffix [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate panelClass="panel-system"></mat-datepicker>
          </mat-form-field>

          <mat-form-field *ngIf="!selectDex && (maxDays != 0)" fxFlex style="margin-top: 15.5px; margin-left: 7.5px;" class="system-form-fieldmat-date-default">
            <mat-label>Fecha Final</mat-label>
            <input matInput formControlName="endDate" [matDatepicker]="endDate" [max]="verifyStart()" [min]="maxDate">
            <mat-datepicker-toggle matIconSuffix [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate panelClass="panel-system"></mat-datepicker>
          </mat-form-field>
        </div>

      </form>
    </div>

    <div [ngStyle]="{'visibility':!hasDates ? 'visible' : 'hidden'}" fxLayout="row" fxLayoutAlign="start center" fxFlex>
      <mat-icon *ngIf="!hideFilter" class="app-filter-input-icon">search</mat-icon>
      <input *ngIf="!hideFilter" fxFlex class="app-filter-input" #filter placeholder="Buscar&hellip;">
    </div>
    <ng-content select=".actions"></ng-content>
    <button *ngIf="addDownload" type="button" [disabled]="!form?.valid" mat-raised-button color="primary" (click)="sendReporthButton()">
      Generar
    </button>
  </div>
  <ng-content></ng-content>
</div>
